import { render } from "./CartSummary.vue?vue&type=template&id=2052fa46"
import script from "./CartSummary.vue?vue&type=script&lang=js"
export * from "./CartSummary.vue?vue&type=script&lang=js"

import "./CartSummary.vue?vue&type=style&index=0&id=2052fa46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__